import { z } from "zod";

import {
  publicCertificateStatusEnumSchema,
  rowCertificatesTypeSchema,
} from "@libs/schemas";
import { formatCertificateStatus } from "@/utils/certificate";

export const certificateSchema = rowCertificatesTypeSchema.omit({
  created_at: true,
  updated_at: true,
});

export const certificateFormSchema = z.object({
  certificate_id: z.string().uuid().optional(),
  certificate_date: z.string().optional(),
  status: publicCertificateStatusEnumSchema,
});

export type CertificateFormType = z.infer<typeof certificateFormSchema>;

export type CertificateStatusType = z.infer<
  typeof publicCertificateStatusEnumSchema
>;
export const certificateStatusOptions =
  publicCertificateStatusEnumSchema.options.map(status => ({
    label: formatCertificateStatus(status),
    value: status,
  }));
